import { render, staticRenderFns } from "./KOLStaffTables.vue?vue&type=template&id=7a633029&"
import script from "./KOLStaffTables.vue?vue&type=script&lang=js&"
export * from "./KOLStaffTables.vue?vue&type=script&lang=js&"
import style0 from "./KOLStaffTables.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports